import { createFileRoute, redirect } from '@tanstack/react-router';

import { RolesPage } from '@/features/members/pages/RolesPage';
import { readEditionFromStorage } from '@/lib/auth/storageEdition';

export const Route = createFileRoute('/_authenticated/roles/')({
  component: RolesPage,
  beforeLoad: () => {
    if (readEditionFromStorage() === 'personal') {
      throw redirect({ to: '/' });
    }
  },
});
